import {
	ADMINGETINTEGRATIONLIST_SUCCESS,
	ADMINGETINTEGRATIONLIST_FAILED,
	RESET_ADMINGETINTEGRATIONLIST,
	LOADING_ADMINGETINTEGRATIONLIST,
	NETWORK_ERROR_ADMINGETINTEGRATIONLIST
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETINTEGRATIONLIST:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINGETINTEGRATIONLIST_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINGETINTEGRATIONLIST_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINGETINTEGRATIONLIST:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINGETINTEGRATIONLIST:
			return (state = initialState);
		default:
			return state;
	}
};
